exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/maintain-report/maintain-report-home/maintain-report-details/maintain-report-details.component.css
// module id = ../../../../../src/app/features/reports/maintain-report/maintain-report-home/maintain-report-details/maintain-report-details.component.css
// module chunks = main